import {useNotification} from "../../../ui/notification/NotificationProvider";
import {useApiNotification} from "../../../ui/ApiNotificationProvider";
import React, {useEffect, useState} from "react";
import {run} from "../../../../utils/function-util";
import {getAllMemberships, getOrganizationUnit} from "../../../../api/organization-unit-functions";
import {OrganizationUnit} from "../../../../models/organization";
import {exportDataToCsv} from "../../../../utils/export-to-csv";
import {useOrganization} from "../../../organizations/organization-context";
import {useTranslation} from "react-i18next";
import Loader from "../../../ui/Loader";

interface ExportMembersProps {
    organizationUnitId: number;
    onError?: (err: any) => void;
    onDone?: () => void;
}

export const ExportMembers = (props: ExportMembersProps) => {
    const {organizationUnitId, onError, onDone} = props;
    const [currentOrganization] = useOrganization();
    const [showLoader, setShowLoader] = useState(true);
    const {t} = useTranslation();
    const {pushError} = useNotification();
    const {handleError} = useApiNotification();

    useEffect(run(
        () => getOrganizationUnit(currentOrganization!.id, organizationUnitId),
        exportToCsv,
        handleError
    ), [organizationUnitId]);


    async function exportToCsv(organizationUnit: OrganizationUnit) {
        const membersCsvContentBuilder = async () => {
            const memberships = await getAllMemberships(currentOrganization!.id, organizationUnitId);

            const data = memberships.items.map((m: any) => [
                m.firstName,
                m.lastName,
                m.email
            ]);

            const headers = [
                t(`_Common.Labels.FirstName`),
                t(`_Common.Labels.LastName`),
                t(`_Common.Labels.Email`)
            ]
            return {data, headers};
        }

        const membersCsvFilenameBuilder = async () => {
            return `${t(`Members.ExportFilename`, {
                organizationName: currentOrganization?.name,
                organizationUnitName: organizationUnit?.name
            })}.csv`
        }

        try {
            void await exportDataToCsv(
                membersCsvContentBuilder,
                membersCsvFilenameBuilder
            );
            if (typeof onDone == "function")
                onDone();
        } catch (err) {
            pushError({
                message: t('_Shared.CSV.Error.ExportFailed')
            });
            if (typeof onError == "function")
                onError(err);
        } finally {
            setShowLoader(false);
        }
    }

    return <Loader show={showLoader}/>
}
